import {AlphabeticalisedFilters} from "models/Filter"
import {CATEGORY_FILTERS_REGEX} from "../../../config/constants"

export const alphabeticaliseFiltersUrlSegment = (filters: string): AlphabeticalisedFilters => {
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    const filtersArray: string[] = filters.match(CATEGORY_FILTERS_REGEX) || []

    filtersArray.sort()

    let filterString = ""
    let isortElement = ""
    let minPrice = ""
    let maxprice = ""
    let dash = ""

    for (let index = 0; index < filtersArray.length; index += 1) {
        const element = filtersArray[index]
        if (element.includes("isort")) {
            isortElement = element
        } else if (element.includes("minprice")) {
            minPrice = element
        } else if (element.includes("maxprice")) {
            maxprice = element
        } else {
            dash = filterString.length < 1 ? "" : "-"
            filterString += `${dash}${element}`
        }
    }

    const price = minPrice !== "" && maxprice !== "" ? `${minPrice}-${maxprice}` : ""

    return {sortedFilters: filterString, isort: isortElement, price}
}

// Category segment ordered by Gender - Category - others in alphabetical order
export const alphabeticaliseCategoryUrlSegment = (filters: string): string => {
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    const filtersArray: string[] = filters.match(CATEGORY_FILTERS_REGEX) || []

    let filterString = ""
    filtersArray
        .sort()
        .sort((first, second) => {
            if (first.startsWith("category") && second.startsWith("category")) return 0

            if (first.startsWith("category")) return -1
            if (second.startsWith("category")) return 1

            return 0
        })
        .sort((first, second) => {
            if (first.startsWith("gender") && second.startsWith("gender")) return 0
            if (first.startsWith("gender")) return -1
            if (second.startsWith("gender")) return 1

            return 0
        })

    const filterArrayLength = filtersArray.length
    let dash = ""
    filtersArray.forEach((filter, index) => {
        dash = index !== filterArrayLength - 1 ? "-" : ""
        filterString += `${filter}${dash}`
    })

    return filterString
}

export default alphabeticaliseFiltersUrlSegment
